import {Component} from 'react';
import h from 'react-hyperscript';
import {h3, p} from 'Components/Typography/Typography';
import {getIndexByProperty} from 'Src/utils/utils';
import CardWithSidebar from 'Components/Cards/CardWithSidebar';
import Button from 'Components/Buttons/Buttons';
import CheckboxGroup from 'Components/Form/Checkbox';
import SurveyRadioGroup from 'Components/Form/RadiosHorizontal';
import SurveyHeader from 'Pages/TransformationSurvey/SurveyHeader/SurveyHeader';
import SurveyElementHeader from
  'Pages/TransformationSurvey/SurveyElementHeader/SurveyElementHeader';
import Image from 'Components/Image/Image';

function getCheckboxesDefaultValue(values) {
  return Array.isArray(values) ? values : [];
}

class SurveyElement extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.elementStateId = `${this.props.id.split('--')[0]}Values`;

    const fieldValues = props.fieldValues[this.elementStateId];
    const priorityCheckboxes = fieldValues ?
      getCheckboxesDefaultValue(fieldValues.surveyValues.priorityCheckboxes) :
      [];

    this.state = {
      hasError: priorityCheckboxes.length > 3,
      mountedClass: 'fade-out',
      buttonClasses: this.checkLastStepProgress(),
      elementComplete: {
        total: props.content.questions.length + 1,
        answered: 0,
        remaining: props.content.questions.length + 1,
        percentage: 0,
      },
      surveyValues: {
        priorityCheckboxes,
        progress: [],
      },
    };

    this.handleCheckboxes = this.handleCheckboxes.bind(this);
    this.handleRadios = this.handleRadios.bind(this);
    this.checkLastStepProgress = this.checkLastStepProgress.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.setMountedClass();
    if (this.props.fieldValues[this.elementStateId]) {
      const values = this.props.fieldValues[this.elementStateId].surveyValues;
      this.setSurveyValues(values);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setMountedClass();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.totalPercentComplete !== prevProps.totalPercentComplete ||
      prevState.surveyValues.length !== this.state.surveyValues.length ||
      prevState.elementComplete.answered !== this.state.elementComplete.answered
    ) {
      this.setState({
        buttonClasses: this.checkLastStepProgress(),
      });
    }
  }

  setSurveyValues(values) {
    this.setState({
      surveyValues: values,
    }, () => {
      this.setState({
        elementComplete: this.checkPercentComplete(),
        buttonClasses: this.checkLastStepProgress()});
    });
  }

  setMountedClass() {
    let value;
    if (this._isMounted) {
      value = 'fade-in';
    } else {
      value = 'fade-out';
    }
    this.setState({
      mountedClass: value,
    });
  }

  checkElementProgress() {
    const currentElementProgress = this.checkPercentComplete();
    this.setState({
      elementComplete: currentElementProgress,
    }, () => {
      this.props.saveValues(this.state, this.elementStateId, false);
      this.checkLastStepProgress();
    });
  }

  checkLastStepProgress() {
    if (!this.state || (
      this.state.elementComplete &&
      this.state.elementComplete.percentage < 1
    )) {
      return 'button--centered button--disabled';
    } else {
      return 'button--centered button--no-max-width';
    }
  }

  get surveyIncomplete() {
    const isntComplete = this.props.completedSteps.length < 8;
    return this.props.step === 'fundingSustainability' && isntComplete;
  }

  checkPercentComplete() {
    const values = this.state.surveyValues;
    const numTotal = this.state.elementComplete.total;
    let numAnswered = 0;

    if (values.progress && values.progress.length > 0) {
      numAnswered = numAnswered + values.progress.length;
    }

    if (
      values.priorityCheckboxes && values.priorityCheckboxes.length > 0 &&
      values.priorityCheckboxes.length < 4
    ) {
      numAnswered = numAnswered + 1;
    }

    const completeObj = {
      total: numTotal,
      answered: numAnswered,
      remaining: numTotal - numAnswered,
      percentage: numAnswered / numTotal,
    };

    return completeObj;
  }

  handleRadios(event) {
    const selectedName = event.target.getAttribute('name');
    const selectedStep = event.target.getAttribute('datastep');
    const selectedVal = event.target.value;
    const isChecked = event.target.checked;
    const progress = this.state.surveyValues.progress;
    let radioValue;
    if (isChecked && selectedName) {
      const selectedIndex = getIndexByProperty(this.state.surveyValues.progress,
          'name', selectedName);
      radioValue = {
        name: selectedName,
        value: selectedVal,
        type: 'AVG',
        element: 'vision',
        step: selectedStep,
      };
      if (selectedIndex > -1) {
        progress[selectedIndex] = radioValue;
      } else {
        progress.push(radioValue);
      }
      this.setRadioValue(progress);
    }
  }

  setRadioValue(value) {
    this.setState((state, props) => ({
      surveyValues: {
        ...this.state.surveyValues,
        progress: value,
      },
    }), () => {
      this.checkElementProgress();
      this.props.saveValues(this.state, this.elementStateId, true);
    });
  }

  handleCheckboxes(event) {
    const checkedName = event.target.getAttribute('name');
    const checkedStep = event.target.getAttribute('datastep');
    const checkedVal = event.target.value;
    const isChecked = event.target.checked;
    const checkedList = this.state.surveyValues.priorityCheckboxes;

    const checkedObj = {
      name: checkedName,
      value: checkedVal,
      step: checkedStep,
      type: 'PRIORITY',
    };

    if (isChecked) {
      checkedList.push(checkedObj);
    } else {
      const index = checkedList.indexOf(checkedObj);
      checkedList.splice(index, 1);
    }

    if (checkedList.length > 3) {
      this.setCheckboxError(true);
      this.setCheckboxValue(checkedList);
    } else {
      this.setCheckboxError(false);
      this.setCheckboxValue(checkedList);
    }
  }

  setCheckboxError(value) {
    this.setState({
      hasError: value,
    });
  }

  getMessage() {
    const {state, props} = this;
    return (
      state &&
      state.elementComplete &&
      state.elementComplete.percentage < 1
    ) ? props.content.buttons.continueMessage
        .replace('XX%', state.elementComplete.remaining) :
      '';
  }

  setCheckboxValue(value) {
    this.setState((state, props) => ({
      surveyValues: {
        ...this.state.surveyValues,
        priorityCheckboxes: value,
      },
    }), () => {
      this.checkElementProgress();
      this.props.saveValues(this.state, this.elementStateId, true);
    });
  }

  render() {
    return (
      h('div', {
        className: 'container survey-element__container',
        id: this.props.id,
      }, [

        h(SurveyHeader, {
          key: 'survey-element-header__key',
          districtName: this.props.districtName,
          totalPercentComplete: this.props.totalPercentComplete,
        }, null),

        h(CardWithSidebar, {
          key: 'vision-card__key',
          className: this.props.className,
          goToStep: this.props.goToStep,
          totalPercentComplete: this.props.totalPercentComplete,
          showSectionProgress: this.props.showSectionProgress,
          completedSteps: this.props.completedSteps,
          activeStep: this.props.activeStep,
          sidebarItems: this.props.sidebarItems,
          showRemaining: this.props.showRemaining,
          fieldValues: this.props.fieldValues,
        }, [

          h(SurveyElementHeader, {
            answered: this.state.elementComplete.answered,
            remaining: this.state.elementComplete.remaining,
            total: this.state.elementComplete.total,
            showRemaining: this.props.showRemaining,
          }, null),

          h('div', {
            className: `card-main__content ${this.state.mountedClass}`,
          }, [
            h('div', {
              className: 'flex survey-element__title',
            }, [
              h(Image, {
                key: `${this.props.id}-title-icon__key`,
                src: this.props.content.icon,
                className: 'padding-right--micro',
              }, null),
              h(h3, {
                key: 'card-element__title',
              }, this.props.content.title),
            ]),

            h(p, {
              key: 'card-element__desc',
              className: 'text--grey padding-bottom--md',
            }, this.props.content.desc),

            h(p, {
              key: 'card-element__disclaimer',
              className: 'text--grey padding-bottom--md',
            }, this.props.content.elementDisclaimer),

            this.props.content.questions.map((question, i) => {
              return (
                h(SurveyRadioGroup, {
                  key: `${question.id}__key`,
                  id: question.id,
                  index: i,
                  step: question.step,
                  name: question.id,
                  title: question.title,
                  desc: question.desc,
                  onChange: this.handleRadios,
                  surveyValues: this.state.surveyValues,
                })
              );
            }),

            h(CheckboxGroup, {
              key: this.props.content.elementPriorities.id,
              index: this.props.content.questions.length + 1,
              hasError: this.state.surveyValues.priorityCheckboxes.length > 3,
              errorMessage: '* Please select only 3 steps as your priority.',
              id: this.props.content.elementPriorities.id,
              name: this.props.content.elementPriorities.id,
              step: this.props.content.elementPriorities.step,
              title: this.props.content.elementPriorities.title,
              checkedValues: this.state.surveyValues.priorityCheckboxes,
              checkboxes: this.props.content.questions,
              onChange: (e) => {
                this.handleCheckboxes(e);
              },
            }),

            h(Button, {
              key: 'survey-button-icon',
              className: this.state.buttonClasses,
              to: '#',
              type: 'flat',
              onClick: (e) => {
                e.preventDefault();
                this.props.saveAndContinue(
                    this.state,
                    this.elementStateId,
                    false
                );
              },
            }, [
              h('span', {
                className: 'material-icons',
              }, 'arrow_downward'),
              h('span', {
                className: 'button__text',
              }, this.props.content.buttons.continue),
            ]),

            h(p, {
              key: 'survey-button-message',
              className:
                `text--grey text--center padding-top--micro text-center
                footnote${
                  this.state.elementComplete.percentage < 1 ?
                    '' :
                    'hide--mobile hide--desktop'
      }`,
            }, this.getMessage()),
          ]),
        ]),
      ])
    );
  }
}

export default SurveyElement;
